import _ from 'lodash'
import { isNil } from 'core/service/lib/type-check'
import { connect } from 'react-redux'

const isApEcare = (rider) => !isNil(rider) && (!isNil(rider.apRider) || !isNil(rider.ecareRider))

const isEsciWpeip85 = (rider) => !isNil(rider) && (!isNil(rider.esciRider) || !isNil(rider.wpeip85Rider))

const isSelectedRider = (rider) => {
  if (isApEcare(rider)) {
    return true
  }

  if (isEsciWpeip85(rider)) {
    return true
  }

  if (isNil(rider) || _.isEmpty(rider) || (!isApEcare(rider) && !(rider.isSelected && rider.isSelectable))) {
    return false
  }
  return rider.isSelected
}

export const enchancedRiderComponent = (Component) => {
  return (props) => {
    if (!props || !isSelectedRider(props.rider)) {
      return null
    }

    return <Component {...props} />
  }
}

export const enhancedRiderConnect = (mapStateToProps, mapDispatchToProps, mergeProps, options) =>
  _.flow(enchancedRiderComponent, connect(mapStateToProps, mapDispatchToProps, mergeProps, options))
